import mixpanel from "mixpanel-browser";
import { Provider } from "../provider";
import type { Analytics } from "../analytics";
import type { ProviderListeners } from "../provider-listeners";

type IConfig = {
  token: string;
  debug: boolean;
};

export class MixPanel extends Provider {
  public key = "mixpanel";
  protected analytics: Analytics | undefined;
  protected listeners: ProviderListeners = {
    setSuperProperties: (payload) => {
      mixpanel.register({
        businessId: payload.businessId,
        businessName: payload.businessName,
        outletId: payload.outletId,
        outletName: payload.outletName,
        orderingMode: payload.orderingMode,
        salesChannel: payload.salesChannel,
      });
      return payload;
    },
    userAnonymize: (payload) => {
      mixpanel.reset();
      return payload;
    },
    userIdentify: (payload) => {
      this.identifyUser(payload.id, payload.name ?? "", payload.email ?? "");
      return payload;
    },
    pageView: (payload) => {
      mixpanel.track_pageview();
      return payload;
    },
    viewMenu: (payload) => {
      mixpanel.track("Viewed Menu", {
        menuId: payload.id,
        menuSlug: payload.slug,
      });
      return payload;
    },
    orderSuccess: (payload) => {
      mixpanel.track("Placed Order", {
        orderUid: payload.orderUid,
      });
      return payload;
    },
    orderFailure: (payload) => {
      mixpanel.track("Place Order Failed", {
        orderUid: payload.orderUid,
        reason: payload.reason ?? "Unknown",
      });
      return payload;
    },
    viewCrossSell: (payload) => {
      mixpanel.track("Viewed Cross-Sell", {
        flow: "cross-sell",
        surface: payload.surface,
        itemCount: payload.itemCount,
      });
      return payload;
    },
  };

  private config: IConfig;

  constructor(config: IConfig) {
    super();
    this.config = config;
  }

  protected onInstall(): void {
    if (!this.config.token) {
      throw new Error("No MixPanel token provided");
    }

    mixpanel.init(this.config.token, {
      debug: this.config.debug,
    });
    mixpanel.register({
      product: "Online Ordering",
    });
  }

  private identifyUser(id: string, name: string, email: string): void {
    const user = {
      id,
      name,
      email,
    };

    mixpanel.identify(user.id);
    mixpanel.people.set({
      ID: user.id,
      $name: user.name,
      $email: user.email,
    });
  }
}
